import React, { memo } from 'react';
import { DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));

const DialogTitleWithCloseBtn = (props) => {

  const { titleCss, title, closeFn } = props;

  const classes = useStyles();

  return (
    <DialogTitle className={`${classes.root} dialog-title ${titleCss || ''}`}>
      {title}
      <IconButton
        aria-label="close"
        onClick={event => closeFn(event)}
        className={classes.closeButton}
        size="large">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default memo(DialogTitleWithCloseBtn);
